import React, { useRef, useEffect, useState } from "react";
import lottie from "lottie-web";

export default function Lottie({
  animationData,
  lottieClass,
  onLottieClickIn,
  onLottieClickOut,
  loop = false,
}) {
  const ref = useRef();
  const lottieRef = useRef();
  const [direction, setDirection] = useState(1);

  useEffect(() => {
    lottieRef.current = lottie.loadAnimation({
      container: ref.current, // the dom element that will contain the animation
      renderer: "svg",
      loop: loop,
      autoplay: false,
      animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    });
  }, []);

  const onClick = () => {
    if (loop === true) {
      lottieRef.current.play();
    } else {
      lottieRef.current.setDirection(direction);
      lottieRef.current.play();
      if (direction === 1) {
        onLottieClickIn && onLottieClickIn();
        setDirection(-1);
      } else {
        onLottieClickOut && onLottieClickOut();
        setDirection(1);
      }
    }
  };

  return (
    <div
      onClick={onClick}
      className={`lottie ${lottieClass}`}
      ref={ref}
      width={100}
    ></div>
  );
}
